// Formats d'affichage en français.

export function date(valeur: string | Date | null | undefined): string {
  if (!valeur) return 'non renseigné';
  const d = typeof valeur === 'string' ? new Date(valeur) : valeur;
  if (Number.isNaN(d.getTime())) return 'non renseigné';
  return d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });
}

export function dateHeure(valeur: string | Date | null | undefined): string {
  if (!valeur) return 'non renseigné';
  const d = typeof valeur === 'string' ? new Date(valeur) : valeur;
  if (Number.isNaN(d.getTime())) return 'non renseigné';
  return d.toLocaleString('fr-FR', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

/** « il y a 4 minutes », « il y a 2 heures », sinon la date. */
export function fraicheur(valeur: string | Date | null | undefined, maintenant = new Date()): string {
  if (!valeur) return 'date de calcul inconnue';
  const d = typeof valeur === 'string' ? new Date(valeur) : valeur;
  const minutes = Math.round((maintenant.getTime() - d.getTime()) / 60_000);
  if (minutes < 1) return 'à l\'instant';
  if (minutes < 60) return `il y a ${minutes} minute${minutes > 1 ? 's' : ''}`;
  const heures = Math.round(minutes / 60);
  if (heures < 24) return `il y a ${heures} heure${heures > 1 ? 's' : ''}`;
  return `le ${dateHeure(d)}`;
}

/** Date ISO (AAAA-MM-JJ) locale. */
export function isoJour(d: Date): string {
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const j = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${m}-${j}`;
}

/** Valeur d'un champ datetime-local convertie en ISO 8601 avec fuseau. */
export function versIso(valeurLocale: string): string {
  return new Date(valeurLocale).toISOString();
}

export function pluriel(n: number, singulier: string, plurielForme = `${singulier}s`): string {
  return `${n.toLocaleString('fr-FR')} ${n > 1 ? plurielForme : singulier}`;
}
